<template lang="pug">
div(
  class="tw-h-full tw-flex tw-flex-col tw-max-h-main tw-overflow-hidden tw-bg-white tw-rounded-md tw-mx-4 tw-mt-0 tw-px-4 tw-py-2"
)
  div(class="tw-flex tw-flex-row")
    v-row(no-gutters)
      v-col
        v-row(dense class="tw-mb-0")
          v-btn-toggle(v-model="toggle_exclusive" mandatory)
            v-col(cols="auto")
              v-btn(
                depressed
                :to="{ name: 'settingsCompany' }"
                color="rgba(94,129,244,0.10)"
                height="42"
                class="tw-rounded-md"
              )
                span(class="tw-font-medium tw-pl-1 tw-text-kPurple")
                  v-icon mdi-office-building
                  span(class="tw-pl-1 tw-font-bold") {{ $t('Common.company') }}
            v-col(cols="auto")
              v-btn(depressed :to="{ name: 'settingsTeam' }" color="rgba(94,129,244,0.10)" height="42" class="tw-rounded-md")
                span(class="tw-font-medium tw-pl-1 tw-text-kPurple")
                  v-icon mdi-account-multiple
                  span(class="tw-pl-1 tw-font-bold") {{ $t('Common.team') }}
            v-col(cols="auto")
              v-btn(
                depressed
                :to="{ name: 'settingsBilling' }"
                color="rgba(94,129,244,0.10)"
                height="42"
                class="tw-rounded-md"
              )
                span(class="tw-font-medium tw-pl-1 tw-text-kPurple")
                  v-icon mdi-credit-card-outline
                  span(class="tw-pl-1 tw-font-bold") {{ $t('Common.billing') }}
  div(class=" tw-flex-row tw-flex-grow tw-flex")
    v-row(no-gutters class=" tw-h-full")
      v-col(class="tw-h-full")
        v-fade-transition(mode="out-in")
          router-view
</template>
<script>
export default {
  data() {
    return {
      toggle_exclusive: null,
    };
  },
  created() {
    this.$store.commit('displaySidebar', true);
    this.$store.commit('displayWebsiteToolbar', false);
    this.$store.commit('displayMainToolbar', true);
  },
};
</script>
<style scoped>
.v-icon {
  @apply tw-text-kPurple !important;
}
.v-item--active {
  color: red;
  background-color: #2f53c9 !important;
  color: #ffffff !important;
}

.v-item--active span,
.v-item--active .v-icon {
  color: #ffffff !important;
}
</style>
